import { render, staticRenderFns } from "./PrescriptionSelectorModal.vue?vue&type=template&id=5737b137"
import script from "./PrescriptionSelectorModal.vue?vue&type=script&lang=js"
export * from "./PrescriptionSelectorModal.vue?vue&type=script&lang=js"
import style0 from "./PrescriptionSelectorModal.vue?vue&type=style&index=0&id=5737b137&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports